import { render, staticRenderFns } from "./QueueTablePanel.vue?vue&type=template&id=dd77fb9e&scoped=true"
import script from "./QueueTablePanel.vue?vue&type=script&lang=js"
export * from "./QueueTablePanel.vue?vue&type=script&lang=js"
import style0 from "./QueueTablePanel.vue?vue&type=style&index=0&id=dd77fb9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd77fb9e",
  null
  
)

export default component.exports